var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, Teleport as _Teleport } from "vue";
var _hoisted_1 = { class: "flight-landing-widget__itinerary-area" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer-xl" }, null, -1 /* HOISTED */);
var _hoisted_3 = { class: "heading-h5 flight-landing-widget__month" };
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer-xl" }, null, -1 /* HOISTED */);
var _hoisted_5 = { class: "flight-landing-widget__footer" };
var _hoisted_6 = { class: "flight-landing-widget__footer__terms" };
var _hoisted_7 = { class: "flight-landing-widget__footer__search" };
var _hoisted_8 = /*#__PURE__*/ _createElementVNode("p", { class: "paragraph-note" }, "Showing prices for a 7 day return trip", -1 /* HOISTED */);
var _hoisted_9 = ["disabled"];
var _hoisted_10 = {
    key: 0,
    class: "icon icon-airplane-depart icon--sm",
    "aria-hidden": "true"
};
var _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
import { useElementSize, useUrlSearchParams, watchDebounced, } from '@vueuse/core';
import ItineraryFields from '../ItineraryFields/ItineraryFields.vue';
import { computed, inject, onMounted, provide, ref, watch } from 'vue';
import createAmadeusBestPricesHistogramRequest from '../../lib/createAmadeusBestPricesHistogramRequest';
import optiClient from '../../services/api';
import HistogramRenderer from '../HistogramRenderer/HistogramRenderer.vue';
import MonthWithPrices from './MonthWithPrices.vue';
import convertPriceResponse from '../../lib/convertPriceResponse';
import dayjs from 'dayjs';
import useMatchMedia from '../../hooks/useMatchMedia';
import useOptiContent from '../../hooks/useOptiContent';
import useAmadeusParams from '../../hooks/useAmadeusParams';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
import { getAmadeusPriceTotal } from '../../lib/amadeusPriceDisplayTools';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FlightLandingWidget',
    props: {
        fromAirportCodeDefault: {},
        toAirportCodeDefault: {},
        contentId: {}
    },
    setup: function (__props) {
        var _this = this;
        var _a, _b, _c, _d;
        var props = __props;
        var el = ref(null);
        var itineraries = ref([{}, {}]);
        var apiPricesHistogram = ref();
        var activeMonth = ref();
        var passengerAndCabinClass = ref({
            adults: 1,
            cabin: 'economy',
            youth: 0,
            child: 0,
            infant: 0,
        });
        var isEditing = ref(false);
        var selectedRange = ref([]);
        var isMobile = useMatchMedia('only screen and (max-width: 743px)');
        var lowestPrice = computed(function () {
            if (!convertedPrices.value.lowestFoundPrice) {
                return undefined;
            }
            return Math.round(getAmadeusPriceTotal(convertedPrices.value.lowestFoundPrice, convertedPrices.value.currencies));
        });
        var _e = useOptiContent(props.contentId), data = _e.data, loading = _e.loading, error = _e.error;
        var defaultLabel = (_c = (_b = (_a = data.value) === null || _a === void 0 ? void 0 : _a.searchFlightsButtonLabel) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 'Search flights';
        provide('cms-props', data);
        var width = useElementSize(el).width;
        var fetchAirport = function (airportCode) { return __awaiter(_this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, optiClient.destinations.getApiV1DestinationsAirportsFind(airportCode)];
                    case 1:
                        res = _a.sent();
                        if (res.data[0]) {
                            return [2 /*return*/, res.data[0]];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var setIsEditing = function (value) {
            if (isMobile.value === true) {
                isEditing.value = false;
                window.removeEventListener('click', windowClickHandler);
                window.removeEventListener('scroll', windowScrollHandler);
                return;
            }
            isEditing.value = value;
            if (value === true) {
                window.addEventListener('click', windowClickHandler);
                window.addEventListener('scroll', windowScrollHandler);
            }
            else {
                window.removeEventListener('click', windowClickHandler);
                window.removeEventListener('scroll', windowScrollHandler);
            }
        };
        var windowClickHandler = function (e) {
            if (!e.target)
                return;
            var isInBookingWidget = e.target.closest('.flight-landing-widget') !== null;
            if (!isInBookingWidget) {
                setIsEditing(false);
            }
        };
        var windowScrollHandler = function () {
            if (!el.value) {
                return;
            }
            var rect = el.value.getBoundingClientRect();
            if (rect.bottom < 0) {
                setIsEditing(false);
            }
        };
        var params = useUrlSearchParams('history');
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var fromAirportCode, toAirportCode, airport, airport;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fromAirportCode = params.from
                            ? params.from
                            : props.fromAirportCodeDefault;
                        toAirportCode = params.to
                            ? params.to
                            : props.toAirportCodeDefault;
                        if (!fromAirportCode) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetchAirport(fromAirportCode)];
                    case 1:
                        airport = _a.sent();
                        if (airport) {
                            itineraries.value[0].fromAirport = airport;
                        }
                        _a.label = 2;
                    case 2:
                        if (!toAirportCode) return [3 /*break*/, 4];
                        return [4 /*yield*/, fetchAirport(toAirportCode)];
                    case 3:
                        airport = _a.sent();
                        if (airport) {
                            itineraries.value[0].toAirport = airport;
                        }
                        _a.label = 4;
                    case 4:
                        // Use the URL search params for cabin and passenger counts
                        if (params.cabin) {
                            passengerAndCabinClass.value.cabin = params.cabin;
                        }
                        passengerAndCabinClass.value.adults = params.adults ? parseInt(params.adults) : 1;
                        passengerAndCabinClass.value.youth = params.youth ? parseInt(params.youth) : 0;
                        passengerAndCabinClass.value.child = params.child ? parseInt(params.child) : 0;
                        passengerAndCabinClass.value.infant = params.infant ? parseInt(params.infant) : 0;
                        return [2 /*return*/];
                }
            });
        }); });
        var convertedPrices = computed(function () {
            if (!apiPricesHistogram.value) {
                return {
                    prices: {},
                    lowestFoundPrice: undefined,
                    highestFoundPrice: undefined,
                    currencies: undefined,
                };
            }
            return convertPriceResponse(apiPricesHistogram.value, 'departureDate');
        });
        var size = computed(function () {
            if (width.value > 1080) {
                return 'large';
            }
            else if (width.value > 720) {
                return 'medium';
            }
            return 'small';
        });
        var itinerariesFiltered = computed(function () {
            return itineraries.value.filter(function (itinerary) {
                return !(itinerary === null || itinerary === void 0 ? void 0 : itinerary.ignore);
            });
        });
        var selectDay = function (day) {
            if (itinerariesFiltered.value.length === 2 &&
                selectedRange.value[0] &&
                !selectedRange.value[1] &&
                (dayjs(day.date).isSame(selectedRange.value[0], 'date') || dayjs(day.date).isAfter(selectedRange.value[0]))) {
                selectedRange.value = [selectedRange.value[0], day.date];
            }
            else {
                selectedRange.value = [day.date];
            }
        };
        var fareFamilies = (_d = inject('amadeus-fare-families')) !== null && _d !== void 0 ? _d : [
            'CFFECOBIZ',
            'CFFBIZ',
        ];
        var itinerariesWithDates = computed(function () {
            return itinerariesFiltered.value.map(function (itinerary, index) { return (__assign(__assign({}, itinerary), { departureDate: selectedRange.value[index] })); });
        });
        var amadeusParams = useAmadeusParams({
            itinerariesRef: itinerariesWithDates,
            passengerAndCabinClassRef: passengerAndCabinClass,
        });
        var pricesRequest = computed(function () {
            if (!itinerariesFiltered.value[0].fromAirport ||
                !itinerariesFiltered.value[0].toAirport)
                return null;
            return createAmadeusBestPricesHistogramRequest({
                itineraries: itinerariesFiltered.value,
                tripDuration: 7,
                durationFlexibility: 1,
                fareFamilies: fareFamilies,
            });
        });
        var getFlightPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, optiClient.bookings.postApiV1BookingsFlightsSearch(pricesRequest.value)];
                    case 1:
                        res = _a.sent();
                        apiPricesHistogram.value = res;
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        watchDebounced(function () { return pricesRequest.value; }, function (newValue) {
            if (newValue) {
                getFlightPrices();
            }
        }, { debounce: 300, maxWait: 600 });
        watch(function () { return params.month; }, function (newValue) {
            if (newValue !== activeMonth.value) {
                activeMonth.value = newValue;
            }
        });
        watch(activeMonth, function (newValue) {
            if (newValue !== params.month) {
                params.month = newValue;
            }
        });
        watch(passengerAndCabinClass, function (newValue) {
            params.cabin = newValue.cabin;
            params.adults = newValue.adults.toString();
            params.youth = newValue.youth.toString();
            params.child = newValue.child.toString();
            params.infant = newValue.infant.toString();
        }, { deep: true });
        watch(convertedPrices, function (newValue) {
            var _a;
            var urlParams = new URLSearchParams(window.location.search);
            var activeMonthParam = urlParams.get('month');
            if (activeMonthParam) {
                activeMonth.value = activeMonthParam;
            }
            if (newValue && !activeMonthParam) {
                for (var _i = 0, _b = Object.keys(newValue.prices); _i < _b.length; _i++) {
                    var month = _b[_i];
                    if (newValue.prices[month].total === ((_a = newValue.lowestFoundPrice) === null || _a === void 0 ? void 0 : _a.total)) {
                        activeMonth.value = month;
                        return;
                    }
                }
            }
        });
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "el",
                ref: el,
                class: _normalizeClass(["flight-landing-widget", [{ isEditing: isEditing.value }]]),
                onClick: _cache[3] || (_cache[3] =
                    function () {
                        setIsEditing(true);
                    })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ItineraryFields, {
                        passengerAndCabinClass: passengerAndCabinClass.value,
                        "onUpdate:passengerAndCabinClass": _cache[0] || (_cache[0] = function ($event) { return ((passengerAndCabinClass).value = $event); }),
                        itineraries: itineraries.value,
                        "onUpdate:itineraries": _cache[1] || (_cache[1] = function ($event) { return ((itineraries).value = $event); }),
                        size: size.value,
                        "allow-multi-city": false,
                        "show-dates": false,
                        "conditional-second-row": false
                    }, null, 8 /* PROPS */, ["passengerAndCabinClass", "itineraries", "size"])
                ]),
                (itineraries.value[0].fromAirport && itineraries.value[0].toAirport)
                    ? (_openBlock(), _createBlock(HistogramRenderer, {
                        key: 0,
                        "converted-prices": convertedPrices.value,
                        "active-month": activeMonth.value,
                        "onUpdate:activeMonth": _cache[2] || (_cache[2] = function (val) { return (activeMonth.value = val); })
                    }, _createSlots({
                        footer: _withCtx(function () { return [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _renderSlot(_ctx.$slots, "terms")
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                    _hoisted_8,
                                    _createVNode(AmadeusFormSubmission, { params: _unref(amadeusParams) }, {
                                        default: _withCtx(function () { return [
                                            _createElementVNode("button", {
                                                class: _normalizeClass([
                                                    {
                                                        'button--iconleft': !_unref(isMobile),
                                                    },
                                                    _unref(isMobile) ? 'button--sm' : 'button--md',
                                                    'button',
                                                    'booking-widget__search-button',
                                                ]),
                                                disabled: itinerariesFiltered.value.length !== selectedRange.value.length,
                                                type: "submit"
                                            }, [
                                                (!_unref(isMobile))
                                                    ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(_unref(defaultLabel)), 1 /* TEXT */)
                                            ], 10 /* CLASS, PROPS */, _hoisted_9)
                                        ]; }),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["params"])
                                ])
                            ]),
                            _hoisted_11
                        ]; }),
                        _: 2 /* DYNAMIC */
                    }, [
                        (_unref(isMobile))
                            ? {
                                name: "default",
                                fn: _withCtx(function (_a) {
                                    var date = _a.date;
                                    return [
                                        _createVNode(MonthWithPrices, {
                                            range: itinerariesFiltered.value.length === 2,
                                            month: new Date(date),
                                            itineraries: itinerariesFiltered.value,
                                            "selected-range": selectedRange.value,
                                            "onDay:clicked": selectDay
                                        }, null, 8 /* PROPS */, ["range", "month", "itineraries", "selected-range"])
                                    ];
                                }),
                                key: "0"
                            }
                            : undefined,
                        (!_unref(isMobile) && activeMonth.value)
                            ? {
                                name: "month-large",
                                fn: _withCtx(function () { return [
                                    _hoisted_2,
                                    _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(dayjs)(activeMonth.value).format('MMMM YYYY')), 1 /* TEXT */),
                                    _createVNode(MonthWithPrices, {
                                        "is-large": "",
                                        range: itinerariesFiltered.value.length === 2,
                                        month: new Date(activeMonth.value),
                                        itineraries: itinerariesFiltered.value,
                                        "selected-range": selectedRange.value,
                                        "onDay:clicked": selectDay
                                    }, null, 8 /* PROPS */, ["range", "month", "itineraries", "selected-range"]),
                                    _hoisted_4
                                ]; }),
                                key: "1"
                            }
                            : undefined
                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["converted-prices", "active-month"]))
                    : _createCommentVNode("v-if", true),
                (lowestPrice.value)
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 1,
                        to: "[data-flight-from-currency]"
                    }, [
                        _createTextVNode(_toDisplayString(convertedPrices.value.lowestFoundPrice ? 'From ' : undefined) + _toDisplayString((_a = convertedPrices.value.lowestFoundPrice) === null || _a === void 0 ? void 0 : _a.currencyCode), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                (lowestPrice.value)
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 2,
                        to: "[data-flight-from-price]"
                    }, [
                        _createTextVNode(_toDisplayString(lowestPrice.value.toLocaleString('en-US', {
                            minimumFractionDigits: 0,
                        })), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
